import { Container, Heading, Stack, Text } from "@generalapplications/ui";

import { Tag } from "@/app/common/components/composite/feedback/Tag";
import { formatText } from "@/app/common/functions/format/formatText";

export type SectionHeaderProps = {
  eyebrow?: string;
  title: string;
  copy?: string;
};

/** A section's label, title and the line under it, held to a reading measure. */
export function SectionHeader({ eyebrow, title, copy }: SectionHeaderProps) {
  return (
    <Container width="lg" align="start">
      <Stack gap="md" align="start">
        {eyebrow && <Tag>{formatText(eyebrow)}</Tag>}
        <Heading level={2} size="xxl">
          {formatText(title)}
        </Heading>
        {copy && <Text variant="prose">{formatText(copy)}</Text>}
      </Stack>
    </Container>
  );
}
